export default (id = ':id') => `/customers/${id}`;
